import * as moment from "moment";
export var toCamelCase = function (string) {
    if (string)
        return string.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    else
        return "";
};
export var formatRequestTypeText = function (text) {
    if (text && text.length) {
        var textArr = text.split("");
        textArr[0] = textArr[0].toUpperCase();
        textArr[3] = textArr[3].toUpperCase();
        textArr.splice(3, 0, "-");
        return textArr.join("");
    }
    return "";
};
export var convertEPochToDate = function (epoch) {
    if (!!epoch) {
        // const epocdate = moment(new Date(parseInt(epoch)).toLocaleString());
        var epochInt = Number(epoch);
        var epocdate = void 0;
        if (isNaN(epochInt)) {
            epocdate = moment(epoch);
        }
        else {
            epocdate = moment(epochInt);
        }
        //  const today = moment();
        // if (
        //   moment(epocdate.format("DD-MMM-YY")).isSame(today.format("DD-MMM-YY"))
        // ) {
        //   return epocdate.format("hh:mm:ss A");
        // } else {
        //   return epocdate.format("DD-MMM-YY hh:mm:ss A ");
        // }
        return epocdate.format("DD-MMM-YY hh:mm:ss A");
    }
    else
        return "";
};
export var timeDifference = function (targetDate, format) {
    // Parse the target date using moment
    var targetMoment = moment(targetDate, format);
    // Calculate the time difference in milliseconds
    var timeDiffInMilliseconds = moment().diff(targetMoment);
    // Convert milliseconds to minutes and hours
    var minutes = Math.floor(timeDiffInMilliseconds / (1000 * 60));
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    if (days !== 0) {
        return "".concat(days, " days ").concat(hours % 24, " hours ").concat(minutes % (24 * 60), " minutes ago");
    }
    else if (hours !== 0) {
        return "".concat(hours, " hours ").concat(minutes % 60, " minutes ago");
    }
    else {
        return "".concat(minutes, " minutes ago");
    }
};
export var getLatestTime = function (momentTimes, format) {
    var latestTime = moment.max(momentTimes);
    return latestTime.format("HH:mm:ss") === "Invalid date"
        ? ""
        : latestTime.format("HH:mm:ss");
};
export var str2bool = function (value) {
    if (value && typeof value === "string") {
        if (value.toLowerCase() === "true")
            return true;
        if (value.toLowerCase() === "false")
            return false;
    }
    return value;
};
export var convertEpochToDateOnly = function (epoch) {
    if (epoch) {
        var epochInt = Number(epoch);
        var epocdate = void 0;
        if (isNaN(epochInt)) {
            epocdate = moment(epoch);
        }
        else {
            epocdate = moment(epochInt);
        }
        return epocdate.format("DD-MMM-YY");
    }
    else {
        return "";
    }
};
